/**
 * Settings view component
 * Profile, privacy, data export, E2E encryption toggle
 */

'use client';

import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ThemeToggle } from '@/components/theme/ThemeToggle';
import { Download, Trash2 } from 'lucide-react';

export function SettingsView() {
  return (
    <div className="space-y-8 max-w-4xl mx-auto w-full">
      <div className="space-y-2">
        <h1 className="text-4xl font-bold">Settings</h1>
        <p className="text-muted-foreground">Manage your preferences and account</p>
      </div>

      <Card className="p-8 space-y-8">
        <div>
          <h2 className="text-xl font-semibold mb-6">Appearance</h2>
          <div className="flex items-center justify-between p-4 rounded-lg bg-muted/30">
            <div className="space-y-1">
              <label htmlFor="theme-toggle" className="text-base font-medium">
                Theme
              </label>
              <p className="text-sm text-muted-foreground">Switch between light and dark mode</p>
            </div>
            <ThemeToggle />
          </div>
        </div>

        <div className="border-t border-border pt-8">
          <h2 className="text-xl font-semibold mb-6">Privacy & Security</h2>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 rounded-lg bg-muted/30">
              <div className="space-y-1">
                <label className="text-base font-medium">End-to-End Encryption</label>
                <p className="text-sm text-muted-foreground">
                  Encrypt journal entries client-side for maximum privacy
                </p>
              </div>
              <input type="checkbox" className="h-5 w-5 rounded border-border accent-primary" />
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-8">
          <h2 className="text-xl font-semibold mb-6">Data Management</h2>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 rounded-lg bg-muted/30">
              <div className="space-y-1">
                <label className="text-base font-medium">Export Data</label>
                <p className="text-sm text-muted-foreground">
                  Download your journal entries, habits, and ritual history as CSV
                </p>
              </div>
              <Button variant="outline" className="shrink-0">
                <Download className="h-4 w-4 mr-2" />
                Export
              </Button>
            </div>
            <div className="flex items-center justify-between p-4 rounded-lg bg-destructive/5 border border-destructive/20">
              <div className="space-y-1">
                <label className="text-base font-medium text-destructive">Delete All Data</label>
                <p className="text-sm text-muted-foreground">
                  Permanently delete all your data. This cannot be undone.
                </p>
              </div>
              <Button variant="destructive" className="shrink-0">
                <Trash2 className="h-4 w-4 mr-2" />
                Delete
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
